module.exports = __webpack_public_path__ + "banner.7ae89b96.png";